import { maskedTextFieldFactory } from "../maskedTextFieldFactory";

const formatCnpjMask = (value?: string): string => {
  if (!value) return "";
  const sanitized = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
  const root = sanitized.slice(0, 12);
  const checkDigits = sanitized.slice(12, 14).replace(/[^0-9]/g, "");
  return [
    root.slice(0, 2),
    root.length > 2 ? `.${root.slice(2, 5)}` : "",
    root.length > 5 ? `.${root.slice(5, 8)}` : "",
    root.length > 8 ? `/${root.slice(8, 12)}` : "",
    checkDigits ? `-${checkDigits}` : "",
  ].join("");
};

export const CNPJTextField = maskedTextFieldFactory(formatCnpjMask);
